import React from 'react';
import { Themes, Colors } from '../../ts/enums';
import css from './index.module.scss';
import { Placeholder, mediaApi } from '@sitecore-jss/sitecore-jss-react';

const SectionWrap = ({ fields, rendering }) => {
  const backgroundImageUrl = fields?.backgroundImage?.value?.src ? mediaApi.updateImageUrl(fields.backgroundImage.value.src.split('?')[0]) : "";

  return (
    <div className={css.container}
      data-theme={fields?.theme?.fields?.color?.value || Themes.DARK}
      data-alignment={fields?.backgroundImageAlignment?.fields?.align?.value ||
        'center'}
      data-showaccentbar={fields?.showAccentBar?.value || false}
      data-accentcolor={fields?.accentColor?.fields?.color?.value || Colors.RED}
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      {rendering && <Placeholder name="jss-section-wrap-content" rendering={rendering} />}
    </div>

  );
}
export default SectionWrap;